import { faker } from '@faker-js/faker';

export const genPhone = (): string => {
  const regex = /[1-9]\d{2}[1-9]\d{6}/;
  return faker.helpers.fromRegExp(regex);
};

export const shuffleArray = (array: any[]) => {
  const copyArray = [...array];
  for (let i = copyArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [copyArray[i], copyArray[j]] = [copyArray[j], copyArray[i]];
  }

  return copyArray;
};

export const applyPagination = <T>(items: T[], limit = 0, offset = 0): T[] => {
  if (!limit && !offset) {
    return items; // return everything
  }

  if (!items || items.length === 0) {
    return [];
  }

  return items.slice(offset, offset + limit);
};

export const genPid = (): string => {
  return `P${faker.number.int({ min: 1000000, max: 9000000 })}`;
};
